import {
  Box,
  Flex,
  Group,
  Skeleton,
  Stack,
  rem,
  useMantineTheme,
} from "@mantine/core";
import { useMobileScreen } from "@/shared/hooks/useMobileScreen";
import TabsList from "@/shared/components/TabList";
import { IconFileText } from "@tabler/icons-react";
import { AGENT_TAB_ICONS, AGENT_TAB_LABELS, AGENT_TABS } from "./agentTabs";
import { INSTRUCTIONS_DESCRIPTION } from "./components/AgentForm";
import { TabSectionHeader } from "./components/TabSectionHeader";

/**
 * Esqueleto de carregamento da página do Agente.
 *
 * Renderiza cabeçalho, abas e os títulos/legendas fixos como conteúdo real e usa
 * skeletons apenas nos campos dinâmicos — espelhando `AgentHeader` + aba
 * Instruções (`AgentForm`), que é a aba inicial.
 */
export const AgentPageSkeleton = () => {
  const theme = useMantineTheme();
  const { isMobileScreen } = useMobileScreen();

  return (
    <Flex
      direction="column"
      mih="100%"
      style={{ scrollbarGutter: "stable" }}
      bg={theme.colors["background_3"][0]}>
      <Box
        maw="1200px"
        mx="auto"
        w="100%"
        flex={1}
        display="flex"
        style={{ flexDirection: "column", minHeight: 0 }}>
        <Flex
          direction="column"
          p={isMobileScreen ? rem(20) : "32px 48px"}
          gap={rem(24)}
          w="100%"
          flex={1}
          style={{ minHeight: 0 }}>
          {/* AgentHeader */}
          <Flex
            justify="space-between"
            align="flex-start"
            wrap="wrap"
            gap={rem(16)}
            direction={isMobileScreen ? "column" : "row"}>
            <Stack
              gap={rem(6)}
              style={{ flex: 1 }}>
              <Group gap={rem(10)}>
                <Skeleton
                  height={rem(34)}
                  width={rem(220)}
                  radius={8}
                />
                <Skeleton
                  height={rem(20)}
                  width={rem(56)}
                  radius={4}
                />
              </Group>
            </Stack>
          </Flex>

          {/* Abas (estáticas) */}
          <TabsList
            options={AGENT_TABS.map((tab) => {
              const TabIcon = AGENT_TAB_ICONS[tab];
              return {
                value: tab,
                label: AGENT_TAB_LABELS[tab],
                icon: <TabIcon size={17} />,
              };
            })}
            activeTab="instrucoes"
            setActiveTab={() => undefined}
          />

          {/* Aba Instruções */}
          <Flex
            direction="column"
            gap="lg"
            w="100%"
            flex={1}
            style={{ minHeight: 0 }}>
            <Stack
              gap={rem(8)}
              style={{ flex: 1, minHeight: 0 }}>
              <TabSectionHeader
                icon={
                  <IconFileText
                    size={20}
                    color="var(--mantine-color-R500-0)"
                  />
                }
                title="Instruções do agente"
                badge="A IA SEGUE"
                description={INSTRUCTIONS_DESCRIPTION}
                action={
                  <Skeleton
                    height={rem(34)}
                    width={rem(150)}
                    radius="md"
                  />
                }
              />
              <Skeleton
                radius={8}
                mt={rem(4)}
                style={{ flex: 1, minHeight: rem(200) }}
              />
              <Skeleton
                height={rem(12)}
                width={rem(140)}
                radius="xl"
              />
            </Stack>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
};

export default AgentPageSkeleton;
